const LOCAL_NAME = 'favoritesStorage'

export function defaultState(): Favorites.FavoritesState {
  return {
    favorites: [],
    loading: false,
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
  }
}

export function getLocalState(): Favorites.FavoritesState {
  const localSetting: Favorites.FavoritesState | undefined = JSON.parse(localStorage.getItem(LOCAL_NAME) || '{}')
  return { ...defaultState(), ...localSetting }
}

export function setLocalState(favoritesState: Favorites.FavoritesState): void {
  localStorage.setItem(LOCAL_NAME, JSON.stringify(favoritesState))
}
